import ScriptWhere from 'stores/script/ScriptWhere'

export interface IHashArguments {
  code: string
  modelId: string
  where: ScriptWhere
  fieldIds: string[]
}

const getScriptHash = ({ code, modelId, where, fieldIds }: IHashArguments) => {
  return JSON.stringify({
    code,
    modelId,
    where: where.serialize(),
    fieldIds,
  })
}

export default getScriptHash
